export const operators = {
  filenameBase: 'operators',
  filenameExtension: 'txt',
  nonstandard: true,
  extension: 'tides',
  schema: [
    {
      name: 'operator_id',
      type: 'text',
      required: true,
      primary: true,
    },
  ],
};
